// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".client-views-pages-location-DeliverForm-___styles__addDescription___o9B3E{padding:1.5em;color:#777;cursor:pointer}", "",{"version":3,"sources":["webpack://./client/views/pages/location/DeliverForm/styles.scss"],"names":[],"mappings":"AAAA,2EACC,aAAA,CACA,UAAA,CACA,cAAA","sourcesContent":[".addDescription {\n\tpadding: 1.5em;\n\tcolor: #777;\n\tcursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addDescription": "client-views-pages-location-DeliverForm-___styles__addDescription___o9B3E"
};
export default ___CSS_LOADER_EXPORT___;
